module.exports = __webpack_public_path__ + "img/empty.a3f3de5b.png";